(function () {
  function isAnyOverlayOpen() {
    return /overflow-hidden/.test(document.body.className);
  }

  function init(bar) {
    var targetButtonId = bar.getAttribute('data-target-button');
    var formSelector = bar.getAttribute('data-form-selector');
    var realButton = document.getElementById(targetButtonId);
    var form = document.querySelector(formSelector);
    var stickyButton = bar.querySelector('[data-sticky-atc-button]');

    if (!realButton || !form || !stickyButton) return;

    var isPastButton = false;

    function render() {
      var shouldShow = isPastButton && !isAnyOverlayOpen();
      bar.classList.toggle('is-visible', shouldShow);
    }

    function syncButtonState() {
      stickyButton.disabled = realButton.disabled;
      stickyButton.classList.toggle('is-loading', realButton.classList.contains('loading'));
    }

    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) return;
      form.requestSubmit();
    });

    var stateObserver = new MutationObserver(syncButtonState);
    stateObserver.observe(realButton, { attributes: true, attributeFilter: ['disabled', 'class'] });
    syncButtonState();

    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          isPastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          render();
        });
      },
      { threshold: 0 }
    );
    visibilityObserver.observe(realButton);

    var bodyObserver = new MutationObserver(render);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function initAll() {
    document.querySelectorAll('[data-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
